// =====================================================================
// Financeiro — Petty Cash: QUEM É DO ESCRITÓRIO E QUEM É DA LOJA.
//
// Fonte ÚNICA das duas telas do sub-módulo (Registrar Despesa e Controle).
// Antes cada uma tinha a sua cópia, e o Formulário tinha uma cópia ERRADA:
//
//     const isGerente = user?.perfil === 'Gerente' || 'Gerente Plantao';
//
// ⚠️ Esse `||` compara com uma STRING NÃO-VAZIA, que é sempre verdadeira — a
//    variável valia `true` para todo mundo. Efeito: o seletor de loja ficava
//    desabilitado até para o Admin e o Financeiro, travado na loja do cadastro
//    deles. Não dava erro nenhum; só não deixava lançar despesa de outra loja.
//    (Encontrado em 17/09/2026, ao abrir o módulo para o Coordenador de
//    Qualidade.)
//
// ⚠️ A trava de VERDADE é o backend (`server-pettycash.js`) — estas listas só
//    decidem o que a tela oferece.
// =====================================================================

/**
 * Quem enxerga (e lança para) TODAS as lojas: o escritório que confere.
 *
 * ⚠️ Casar com `perfilNoModulo(perfil, 'financeiro')`, nunca com o perfil cru:
 *    `Diretoria Op` alcança o Financeiro por herança e responde como `Diretoria`
 *    aqui — sem a tradução ela cairia no ramo da loja e ficaria presa ao
 *    `ESCRITÓRIO` do cadastro, que nem aparece no seletor de lojas.
 * ⚠️ `Operacional` (28/09/2026): acesso total ao Financeiro (nível Admin) — vê e
 *    lança para a rede toda. Só front; o backend recorta por loja e isenta quem
 *    tem `loja = ESCRITÓRIO` (é onde o consultor de operações precisa estar cadastrado).
 */
export const PERFIS_VISAO_TOTAL = ['Admin', 'Financeiro', 'Gerente Adm', 'Diretoria', 'Operacional'];

/**
 * Quem está NA LOJA: lança e confere o caixa dela, e nada além.
 *
 * Os três excluem só o próprio erro recente (lançamento da própria loja, ainda
 * Pendente e com competência no mês vigente) e só confirmam o saque de um mês
 * JÁ ENCERRADO — durante o mês corrente ainda há despesa entrando.
 *
 * ⚠️ `Coordenador de Qualidade` entrou em 17/09/2026 (Julia), equiparado ao
 *    Gerente — o mesmo desenho que ele já tem no Estorno, no GPRS e no Chamados.
 * ⚠️⚠️ Mudou esta lista, muda o `PERFIS_DE_LOJA` do `server-pettycash.js` (rota
 *    `/sacar`) e o `authorizeRoles` do `DELETE /:id`. Abrir só aqui dá botão que
 *    devolve 403 — o pior lugar para descobrir a permissão; abrir só lá dá
 *    permissão sem caminho.
 * ⚠️ Grafia do BANCO: 'Gerente Plantao', sem acento e sem cedilha.
 */
export const PERFIS_DE_LOJA = ['Gerente', 'Gerente Plantao', 'Coordenador de Qualidade'];
